module.exports = __webpack_public_path__ + "img/productSatellite_22.7d20df67.png";